import React, { useState } from "react";
import "./ChangePassword.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Hook de autenticação
import { useAuthValidation } from "../../../hooks/useAuthValidation";
// API configurada
import api from "../../../services/api";
// Layout padrão
import DefaultLayout from "../../components/Layouts/DefaultLayout";

function ChangePassword() {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation();
  const [formUser, setFormUser] = useState({ password: "", password_confirmation: "" });

  // Enquanto estiver carregando, mostra apenas o indicador sem layout
  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  // Se não houver usuário, significa que já houve redirecionamento e não deve renderizar nada
  if (!user) {
    return null;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    try {
      await api.post("/user/update/password", formUser, {
        headers: { "Content-Type": "application/json" },
      });
      navigate("/perfil");
    } catch (error) {
      console.error("Erro:", error);
      if (error.response && error.response.data) {
        const serverErrors = error.response.data;
        const formattedErrors = Object.fromEntries(Object.entries(serverErrors).map(([key, value]) => [key, value[0]]));
        setErrors(formattedErrors);
      } else {
        setErrors({ general: t("common-submit-error") });
      }
    }
  };

  return (
    <DefaultLayout>
      <section className="changePassword">
        <div className="container">
          <span>{t("change-password-title")}</span>
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              name="password"
              placeholder={t("change-password-input-1")}
              onChange={handleChange}
              required
            />
            {errors.password && <p className="error">{errors.password}</p>}
            <input
              type="password"
              name="password_confirmation"
              placeholder={t("change-password-input-2")}
              onChange={handleChange}
              required
            />
            {errors.password_confirmation && <p className="error">{errors.password_confirmation}</p>}

            {errors.general && <p className="error">{errors.general}</p>}

            <button type="submit">{t("change-password-button")}</button>
          </form>
        </div>
      </section>
    </DefaultLayout>
  );
}

export default ChangePassword;
